// The areas of an agent a diff groups changes by, in the Versions tab's order. Kept apart with no imports, so the
// schemas that describe a diff can load before the diff itself.
export const AGENT_DIFF_SECTIONS = [
    { id: 'persona', title: 'Persona & objective' },
    { id: 'flow', title: 'Conversation flow' },
    { id: 'intakeForm', title: 'Intake form' },
    { id: 'rules', title: 'Advanced rules' },
    { id: 'configuration', title: 'Configuration' },
    { id: 'voice', title: 'Voice' },
    { id: 'variables', title: 'Variables & analysis' },
    { id: 'actions', title: 'Actions' },
    { id: 'preCall', title: 'Pre-conversation workflow' },
    { id: 'postCall', title: 'Post-conversation workflow' }
];
// An email agent's own areas, drawn the same way beside Persona & objective and Actions: its playbooks, and a playbook's
// own settings.
export const EMAIL_DIFF_SECTIONS = [
    { id: 'playbooks', title: 'Playbooks' },
    { id: 'playbook', title: 'Playbook' }
];
//# sourceMappingURL=sections.js.map